import React, { forwardRef } from 'react';
import styled from 'styled-components';
import { IStyled } from '../../../styles/types';
import { SvgIcon } from '../../Icon';
import InputField from '../InputField';
import { theme } from '../../../styles/theme';

interface IProps extends IStyled {
  value: string;
  onChange: (value: string) => void;
  onKeyDown?: (event: React.KeyboardEvent<HTMLInputElement>) => void;
  placeholder?: string;
  autoFocus?: boolean;
  isFullWidth?: boolean;
}

const Container = styled.div<{ $isFullWidth?: boolean }>`
  position: relative;
  width: 100%;
  max-width: ${({ $isFullWidth }) => ($isFullWidth ? '100%' : '240px')};
`;
const StyledIcon = styled(SvgIcon)`
  position: absolute;
  top: 6px;
  left: 6px;
  fill: ${theme.colors.secondary400};
`;
const StyledInput = styled(InputField)`
  padding-left: 24px;
  &:focus + ${StyledIcon} {
    fill: ${theme.colors.mainBlue};
  }
`;

const SearchInput = forwardRef<HTMLInputElement, IProps>(
  (
    {
      value,
      placeholder = 'Search',
      onChange,
      onKeyDown,
      autoFocus,
      className,
      isFullWidth,
    },
    ref,
  ) => (
    <Container className={className} $isFullWidth={isFullWidth}>
      <StyledInput
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        ref={ref}
        onKeyDown={onKeyDown}
        autoFocus={autoFocus}
      />
      <StyledIcon name="magnifying-glass" width={16} height={16} />
    </Container>
  ),
);

export default SearchInput;
